import React, { useState } from 'react';
import { Modal, Input, Button, Typography, ListView } from '../../../@lib/core';
import { useSession } from '../../../hooks/useSession';
import { useCustomer } from '../../../hooks/useCustomer';
import { useUI } from '../../../hooks/useUI';
import { useRecharge } from '../../../hooks/useRecharge';
import { formatMsisdn } from '../../../utils/formatters';
import TrashIcon from '../../../@lib/icons/TrashIcon';
import * as styles from './ChangeTargetMsisdn.module.css';

function ChangeTargetMsisdn() {
  const { msisdn } = useSession();
  const { customer } = useCustomer();
  const { changeTargetMsisdnOpen, hideChangeTargetMsisdn } = useUI();
  const { setTargetMsisdn, addRecipient, deleteRecipient } = useRecharge();

  const [selected, setSelected] = useState(msisdn);
  const [newRecipient, setNewRecipient] = useState('');

  const allRecipients = customer?.recipients || [];
  const isNewRecipient = selected === newRecipient && newRecipient.length >= 10;
  const listItems = allRecipients.map(r => ({
    key: r.msisdn,
    title: r.msisdn === msisdn ? 'Meu número TIM' : formatMsisdn(r.msisdn),
    subtitle: r.msisdn === msisdn ? formatMsisdn(r.msisdn) : null,
    selected: selected === r.msisdn,
    button:
      r.msisdn !== msisdn ? (
        <button
          className={styles.deleteButton}
          onClick={e => {
            e.stopPropagation();
            deleteRecipient(r.msisdn);
          }}
        >
          <TrashIcon />
        </button>
      ) : null,
  }));

  const handleConfirm = async () => {
    const recipientToAdd = isNewRecipient ? newRecipient : null;
    const targetToSet = selected;

    hideChangeTargetMsisdn();
    setNewRecipient('');
    setSelected(msisdn);

    try {
      if (recipientToAdd) {
        await addRecipient(recipientToAdd);
      }
      setTargetMsisdn(targetToSet);
    } catch {
      // erro já tratado pelo useRecharge via handleError
    }
  };

  const handleClose = () => {
    setSelected(msisdn);
    setNewRecipient('');
    hideChangeTargetMsisdn();
  };

  return (
    <Modal open={changeTargetMsisdnOpen} onClose={handleClose}>
      <div className={styles.content}>
        <Typography variant="h5" fontWeight="bold" color="black">
          Número TIM
        </Typography>
        <Typography variant="tooltip">
          Escolha o número que receberá a recarga:
        </Typography>

        <ListView
          list={listItems}
          onClick={item => {
            setTargetMsisdn(item.key);
            setSelected(msisdn);
            setNewRecipient('');
            hideChangeTargetMsisdn();
          }}
        />

        <Input
          id="new-recipient"
          placeholder="Adicionar novo número"
          value={newRecipient}
          mask="(##) #####-####"
          onChange={value => {
            setNewRecipient(value);
            setSelected(value);
          }}
        />

        <div className={styles.actions}>
          <Button color="primary" variant="outlined" onClick={handleClose}>
            Fechar
          </Button>
          <Button
            color="primary"
            disabled={newRecipient.length < 10}
            onClick={handleConfirm}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ChangeTargetMsisdn;
